// extracted by mini-css-extract-plugin
export default {"category":"category_qqINO","pageHeader":"pageHeader_Ylat_"};